import {
  SAVE_CUSTOMER_HOLIDAY_LIST,
} from '../actions/actionTypes'

const initialState = {
  byCustomerId: {},
}

export default (state=initialState, action) => {
  switch (action.type) {
    case SAVE_CUSTOMER_HOLIDAY_LIST:
      return {
        ...state,
        byCustomerId: {
          ...state.byCustomerId,
          [action.payload.customerId]: action.payload.info,
        },
      }

    default:
      return state
  }
}
